<div class="bg-white p-3">
  <h2>Rail Emissions Report</h2>
  <mat-divider class="bg-light my-2"></mat-divider>
</div>
<ng-container *ngIf="!loading; else mask">
  <div class="container-fluid bg-white flex-grow-1">
    <div class="row h-100 overflow-auto">
      <div class="col-md-4">
        <span class="secondary">Generate a Rail Emissions Report to gain a full view of the benefits of moving freight via rail, including reducing your company’s CO2 emissions.</span>
        <mat-form-field appearance="outline" color="accent" class="w-100">
          <mat-label>Select Parent Company</mat-label>
          <ns-select [formControl]="company" [useVirtual]="true" [loading]="loadingCompanies">
            <mat-option *ngFor="let company of companies" [value]="company">
              {{ company.ultimateCompany }}
            </mat-option>
          </ns-select>
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent" class="w-100" *ngIf="displayYear">
          <mat-label>Select Year</mat-label>
          <mat-select (selectionChange)="yearSelected($event.value)" disableOptionCentering [formControl]="year">
            <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
          </mat-select>
        </mat-form-field>
        <section *ngIf="reports.length > 0" class="py-4">
          <h4>Select Commodity Groups:</h4>
          <div *ngFor="let report of reports" class="p-2">
            <mat-checkbox (change)="checked($event.checked, report)">
              {{ report.reportName }}
              <mat-icon fontSet="fas" fontIcon="fa-info-circle" class="align-baseline" [matTooltip]="tooltips[report.reportName]"></mat-icon>
            </mat-checkbox>
          </div>
          <button mat-flat-button aria-label="Download Selected" color="accent"
                  (click)="download()"
                  [disabled]="selectedIndustries.length === 0"
          >
            Download Selected
            <mat-icon class="align-baseline" fontIcon="fa-file-pdf" fontSet="fas"></mat-icon>
          </button>
        </section>
        <div class="my-2" *ngIf="getCustomText().length > 0">{{ getCustomText() }}</div>
      </div>
      <div class="col-md-8 d-flex flex-column" *ngIf="displayPreView">
        <ngx-extended-pdf-viewer
          [mobileFriendlyZoom]="'100%'"
          [showSecondaryToolbarButton]="false"
          [useBrowserLocale]="true"
          [textLayer]="true"
          [base64Src]="selectedReport?.base64"
          [customToolbar]="toolBar"
        ></ngx-extended-pdf-viewer>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #mask>
  <div class="bg-white flex-grow-1">
    <ns-skeleton [type]="maskType"></ns-skeleton>
  </div>
</ng-template>

<ng-template #toolBar>
  <mat-chip-list aria-label="Report selection" class="p-2 d-block">
    <mat-chip *ngFor="let rep of reports" [selected]="rep.selected" (click)="selectedPdf(rep)">
      <mat-icon class="h-auto" fontIcon="fa-eye" fontSet="fas" *ngIf="rep.selected"></mat-icon>
      {{ rep.reportName }}
    </mat-chip>
  </mat-chip-list>
</ng-template>
